// encryption.service.ts
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  private readonly key: string = 'GJGJHUIYUDFSDNMBKJKLDSAS'; // Replace with your own secret key


  encrypt(data: any): any {
    return CryptoJS.AES.encrypt(data.toString(), this.key).toString();
  }



  decrypt(data:any) {
    const bytes = CryptoJS.AES.decrypt(data, this.key);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  }


  decrypt1() {
    let data = 'U2FsdGVkX1+FwN+4z06mssdL20UmS3zntFyr0lAtYUM='
    const bytes = CryptoJS.AES.decrypt(data, this.key);
    let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    console.log("decryptedData", decryptedData)
  }




}
